angular
	.module 'App.Directive'
	.directive 'matchTextValidator', () ->
		restrict: 'A'
		require: 'ngModel'
		link: (scope, elem, attrs, ctrl) ->
			ctrl.$validators.matchText = (modelValue, viewValue) ->
				ctrl.$isEmpty(viewValue) || viewValue == attrs.matchTextValidator

			attrs.$observe 'matchTextValidator', () ->
				ctrl.$validate()
